import type { FaireProductEntity } from "../../entity_types/product";

export const p_fw1ocgpl: FaireProductEntity = {
  token: "p_fw1ocgpl",
  type: "product",
  name: "Go Nuts Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/6c5b6cfe91191e76c10e5aad37e5b09aab8bab2422c702046d89520e9bc23971/1528334035.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/9c6f4db4b0865a38e98352760f9b6228fbfa54624acaf74ddacf567035629732/1528334035.png",
    "https://cdn.faire.com/fastly/234774bb49bb653e702b32fe61ea7950dc73b97eb95305a5d87d8529b2f68002.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:26.446Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
